export interface SignalDisplayObject {
    signalTag: string;
    color: string;
    level: number;
    strength: string;
    comment: string;
};